module.exports = __webpack_public_path__ + "media/images/sindma/icon-codigos-a14e65ce705f63530533158d4023cdfd.png";